import { ceil } from "lodash-es";
import { createSlice } from "@reduxjs/toolkit";

const metadata = {
  currentPage: 1,
  nextPage: null,
  prevPage: null,
  totalPages: 1,
  totalCount: 0,
};

const initialState = {
  loading: false,
  searching: false,
  error: null,
  byIds: {},
  data: {
    pages: {},
    pagination: metadata,
    search: {
      term: "",
      pages: {},
      pagination: metadata,
    },
  },
};

const generatePaginateMetadata = (current, page, create = false) => {
  if (create) {
    current.totalCount += 1;
    current.totalPages = ceil(current.totalCount / 10);
  }

  return {
    ...current,
    currentPage: page,
    nextPage: page === current.totalPages ? 0 : page + 1,
    prevPage: page === 1 ? 0 : page - 1,
  };
};

export const ownRequestsSlice = createSlice({
  name: "own-requests",
  initialState,
  reducers: {
    fetchOwnRequests: (state) => ({
      ...state,
      loading: true,
    }),
    fetchOwnRequestsCompleted: (state, action) => ({
      ...state,
      loading: false,
      searching: false,
      byIds: action.payload.data.reduce(
        (obj, item) => {
          obj[item.id] = {
            ...item,
          };
          return obj;
        },
        { ...state.byIds }
      ),
      data: {
        ...state.data,
        pages: {
          ...state.data.pages,
          [action.payload.meta.currentPage]: action.payload.data
            ? action.payload.data.map(({ id }) => id)
            : [],
        },
        pagination: action.payload.meta,
      },
    }),
    loadOwnRequests: (state, action) => ({
      ...state,
      loading: false,
      data: {
        ...state.data,
        pagination: generatePaginateMetadata(
          state.data.pagination,
          action.payload.page
        ),
      },
    }),
    searchOwnRequests: (state, action) => ({
      ...state,
      loading: true,
      searching: true,
      data: {
        ...state.data,
        search: {
          term: action.payload.term,
          pages: {
            ...state.data.search.pages,
          },
          pagination: metadata,
        },
      },
    }),
    searchOwnRequestsCompleted: (state, action) => ({
      ...state,
      loading: false,
      byIds: action.payload.data.reduce(
        (obj, item) => {
          obj[item.id] = {
            ...state.byIds[item.id],
            ...item,
          };
          return obj;
        },
        { ...state.byIds }
      ),
      data: {
        ...state.data,
        search: {
          ...state.data.search,
          pages: {
            ...state.data.search.pages,
            [action.payload.meta.currentPage]: action.payload.data.map(
              ({ id }) => id
            ),
          },
          pagination: action.payload.meta,
        },
      },
    }),
    loadSearchOwnRequests: (state, action) => ({
      ...state,
      loading: false,
      searching: true,
      data: {
        ...state.data,
        search: {
          ...state.data.search,
          pagination: generatePaginateMetadata(
            state.data.search.pagination,
            action.payload.page
          ),
        },
      },
    }),
    stopSearchOwnRequests: (state) => ({
      ...state,
      searching: false,
      data: {
        ...state.data,
        search: {
          ...state.data.search,
          term: {},
        },
      },
    }),
  },
});

export const {
  fetchOwnRequests,
  fetchOwnRequestsCompleted,
  loadOwnRequests,
  loadSearchOwnRequests,
  searchOwnRequests,
  searchOwnRequestsCompleted,
} = ownRequestsSlice.actions;
export default ownRequestsSlice.reducer;
